export function openDocumentInNewTab(doc: Blob) {
  const blobUrl = URL.createObjectURL(doc)

  const a = document.createElement("a")
  a.href = blobUrl
  a.download = "document.pdf"
  a.target = "_blank"
  document.body.appendChild(a)
  a.click()
  a.remove()

  URL.revokeObjectURL(blobUrl)
}
